import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ChangesSubject, DataChangesObserver, Logger, TitleService} from '@common-lib';
import {ActivatedRoute, Router} from '@angular/router';
import {VariantEditService} from '../../pages-services/variant-edit.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {memoize} from 'decko';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-variant-edit',
  templateUrl: './variant-edit.component.html',
  styleUrls: ['./variant-edit.component.scss']
})
export class VariantEditComponent implements OnInit {
  haveChanges = false;
  changesCount = 0;
  changesSubject: ChangesSubject;
  countries = [];

  mdOptions = {
    hideIcons: ['Code']
  };

  variantId;
  data: any = {
    loading: true,
    variant: {
      localizations: {},
      productName: '',
      categoryId: '',
    },
    all_drops: [],
  };
  previousSelectedMarket = 'en';
  selectedMarket = 'en';
  imagesList;

  modalRef: BsModalRef;

  @ViewChild('confirmationTemplate')
  confirmationTemplateRef: TemplateRef<any>;

  sortedImagesLists;

  productSelectItems: Array<{ id: number }> = [];
  categorySelectItems: Array<{ id: number, name: string, subcategories: Array<{ id: number, name: string }> }> = [];
  subcategorySelectItems: Array<{ id: number, name: string }> = [];
  subcategories: Array<{ id: number, name: string }> = [];
  dependenciesVariantSelectItems: Array<{ id: number, name: string }> = [];
  dependenciesSubcategorySelectItems: Array<{ real_id: number, id: string }> = [];

  selectedDependencies = [];

  constructor(
      private titleService: TitleService,
      private coreService: Title,
      private route: ActivatedRoute,
      private variantEditService: VariantEditService,
      private datachanges: DataChangesObserver,
      private logger: Logger,
      private toasterService: ToasterService,
      private translateService: TranslateService,
      private modalService: BsModalService,
      private router: Router,
  ) {
    this.variantId = this.route.snapshot.params['id'];
    let title = this.route.snapshot.data && this.route.snapshot.data.title ? this.route.snapshot.data.title : '';
    this.titleService.setTitle({
      title: title,
      params: {variantId: this.variantId}
    });

    this.translateService.get(title).toPromise().then(title => { this.coreService.setTitle(title.replace('{{variantId}}', this.variantId) ); });
  }

  ngOnInit() {
    if (isNaN(Number(this.variantId))) {
      this.getVariantData(0);
    } else {
      this.getVariantData(this.variantId);
    }
    this.variantEditService.getLocalizations().subscribe((data) => this.countries = data);
  }

  getVariantData(id) {
    this.variantEditService.getProduct(id).subscribe((data) => {

      if (id === 0) {
        data.variant = {
          layers: {},
          dependencies: [],
          localizations: {
            en: {
              title: '',
              description: ''
            },
            de: {
              title: '',
              description: ''
            }
          },
          productName: '',
          categoryId: ''
        };

      }
      //
      // let product = data.all_drops.find((p) => p.id === data.variant.productName);
      // if(product){
      //     this.subcategories = this.flatten(product.categories
      //         .map((c) => c.subcategories
      //             .filter((s) => s.id !== data.variant.subcategoryId)
      //             .map((s) => ({id: s.id, name: c.name + ' / ' + s.name}))));
      // }
      this.data = this.createChangesObservation(data);

      this.calculateAllSelectedItems();
    });
  }

  private flatten(arr) {
    return arr.reduce((flat, toFlatten) => {
      return flat.concat(Array.isArray(toFlatten) ? this.flatten(toFlatten) : toFlatten);
    }, []);
  }

  private calculateAllSelectedItems() {
    this.setProductSelectItems();
    this.setCategorySelectedItems();
    this.onChangeCategorySelectItems(false);
    this.setDependenciesVariantSelectItems();
  }

  @memoize()
  getImageList(categoryId, product) {
    const actualViewList = this.getViews(categoryId);
    const result = (this.data.all_media[product] || []).reduce((sortedList, listItem) => {
      actualViewList.forEach(view => {
        if (listItem.includes(view.name)) {
          sortedList[view.name] = [...sortedList[view.name] || [], listItem];
        }
      });

      if (listItem.includes('thumbs')) {
        sortedList.thumbs = [...sortedList.thumbs || [], listItem];
      }
      return sortedList;
    }, {});
    console.log(result);
    return result;
  }

  @memoize()
  getImageName(imagePath) {
    return imagePath.replace(/.*\//, '');
  }

  getViews(categoryId) {
    return this.data.all_views.filter(view => view.categoryId === categoryId);
  }

  private setProductSelectItems() {
    this.productSelectItems = this.data.all_drops.map(item => {
      return {id: item.id};
    });
  }


  private setDependenciesVariantSelectItems() {
    this.dependenciesVariantSelectItems = (this.data.variant.dependencies || []).map((dependencyItem, index) => {
      const subcategory = this.data.all_subcategories
          .find(subcategoryItem => subcategoryItem.real_id === dependencyItem.subcategoryId);
      this.dependenciesSubcategorySelectItems[index] = this.data.all_subcategories
          .filter(subcategoryItem => subcategoryItem.categoryId === subcategory.categoryId);
      return subcategory ? subcategory.variants : false;
    });
  }

  private setCategorySelectedItems() {
    const selectedProduct = this.data.all_drops
        .find(productItem => productItem.id === this.data.variant.productName);
    this.categorySelectItems = selectedProduct ? selectedProduct.categories : [];
  }

  onChangeProduct() {
    this.data.variant.categoryId = '';
    this.data.variant.subcategoryId = '';
    this.setCategorySelectedItems();
  }

  getSelectedCategory() {
    return this.categorySelectItems
        .find(categoryItem => categoryItem.id === this.data.variant.categoryId);
  }

  onChangeCategorySelectItems(isFirstOptionChosen: boolean = true) {
    const selectedCategory = this.getSelectedCategory();
    if (selectedCategory) {
      this.subcategorySelectItems = selectedCategory.subcategories;
    }

    if (isFirstOptionChosen) {
      this.data.variant.subcategoryId = this.subcategorySelectItems[0].id;
    }
  }

  onChangeDependenciesSubcategorySelectItems(dependencyIndex, isFirstOptionChosen: boolean = true) {
    const selectedSubcategory = this.data.variant.dependencies[dependencyIndex];
    const selectedSubcategoryInfo = this.data.all_subcategories
        .find(subcategoryItem => selectedSubcategory && subcategoryItem.real_id === selectedSubcategory.subcategoryId);
    if (selectedSubcategoryInfo) {
      this.dependenciesVariantSelectItems[dependencyIndex] = selectedSubcategoryInfo.variants;
    }
    if (isFirstOptionChosen) {
      this.data.variant.dependencies[dependencyIndex].id = this.dependenciesVariantSelectItems[dependencyIndex][0].id;
    }
  }

  onChangeDependenciesCheckbox({target}, dependencyIndex) {
    if (target.checked) {
      this.selectedDependencies.push({dependencyIndex});
    } else {
      this.selectedDependencies = this.selectedDependencies
          .filter(row => row.dependencyIndex !== dependencyIndex);
    }
  }

  updateVariant() {
    const {variant, variantPrices, variantMarkets} = this.data;
    variant.variantPrices = variantPrices;
    variant.variantMarkets = variantMarkets;
    const {id} = variant;
    this.variantEditService
        .update(id, {variant})
        .subscribe(async (data) => {
          this.data = this.createChangesObservation(data);
          const successMessage = await this.translateService.get('webpanel.save.variant.success_message').toPromise();
          this.toasterService.pop('success', '', successMessage);
          this.calculateAllSelectedItems();
        });
  }

  saveVariant() {
    const {variant, variantPrices, variantMarkets} = this.data;
    variant.variantPrices = variantPrices;
    variant.variantMarkets = variantMarkets;
    this.variantEditService
        .save({variant}, 'en')
        .subscribe(async (data) => {
          this.data = this.createChangesObservation(data);
          const successMessage = await this.translateService.get('webpanel.save.variant.success_message').toPromise();
          this.toasterService.pop({
            type: 'success',
            title: '',
            body: successMessage,
            onShowCallback: () => this.router.navigate([`/variants/${data.variant.id}`])
          });
          this.calculateAllSelectedItems();
        });
  }

  addNewDependency() {
    const selectedCategory = this.getSelectedCategory();
    const subcategories = this.data.all_subcategories
        .filter(subcategoryItem => subcategoryItem.categoryId === selectedCategory.id);
    this.dependenciesSubcategorySelectItems
        .push(subcategories);

    this.data.variant.dependencies.push({subcategoryId: subcategories[0].real_id});
    this.onChangeDependenciesSubcategorySelectItems(this.data.variant.dependencies.length - 1);
  }

  deleteDependency() {
    this.selectedDependencies
        .sort((a, b) => b.dependencyIndex - a.dependencyIndex)
        .forEach(row => {
          this.data.variant.dependencies.splice(row.dependencyIndex, 1);
        });
    this.selectedDependencies = [];
  }

  private createChangesObservation(settings) {
    this.changesCount = 0;
    this.haveChanges = false;
    const subject = this.datachanges.observe(settings);
    this.changesSubject = subject;
    subject.onChanges.subscribe((event) => {
      this.changesCount = event.subject.changesCount;
      this.haveChanges = this.changesCount > 0;
    });
    return subject.getProxy();
  }

  localeChanged() {
    if (this.changesSubject.changesCount > 0) {
      this.modalRef = this.modalService.show(this.confirmationTemplateRef, {class: 'modal-sm'});
    } else {
      this.confirm();
    }
  }

  cancelChanges() {
    if (this.changesSubject) {
      this.changesSubject.cancelChanges();

      this.onChangeCategorySelectItems(false);
      this.data.variant.dependencies.forEach((item, index) => {
        this.onChangeDependenciesSubcategorySelectItems(index, false);
      });
    }
  }

  confirm() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.previousSelectedMarket = this.selectedMarket;
    this.getVariantData(this.variantId);
  }

  decline() {
    this.modalRef.hide();
    this.selectedMarket = this.previousSelectedMarket;
  }

  hasAllowedMarkets(){
    const renderCategory = this.data.all_categories
        .find(categoryItem => categoryItem.real_id === this.data.variant.categoryId);
    return renderCategory && !renderCategory.renderGroup;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/variant-edit/variant-edit.component.ts